import { z } from 'zod';
import { route, defineContract } from '../core/types';

export const gatewayContract = defineContract('gateway', {
	gatewayIsAlive: route({
		method: 'POST',
		path: '/isalive',
		body: z.object({ projectId: z.string().optional(), gatewayId: z.string().optional() }),
		response: z.string(),
		operationId: 'gatewayIsAlive',
		tags: ['Gateway'],
		summary: 'Gateway health check',
	}),
});
